
import React from 'react';

import post001 from "../assets/gallary/post 001.jpg"
import post002 from "../assets/gallary/post 002.jpg"
import post003 from "../assets/gallary/post 003.jpg"
import post004 from "../assets/gallary/post 004.jpg"
import post005 from "../assets/gallary/post 005.jpg"
import post006 from "../assets/gallary/post 006.jpg"
import post007 from "../assets/gallary/post 007.jpg"
import post008 from "../assets/gallary/post 008.jpg"
import post009 from "../assets/gallary/post 009.jpg"
import post010 from "../assets/gallary/post 010.jpg"
import post011 from "../assets/gallary/post 011.jpg"
import post012 from "../assets/gallary/post 012.jpg"

import Footer from 'components/footer';

const Portfolio = () => {
    return (
        <div className='skillsBody'>

            <div className='skillsContainerSection1'>

                <section className='skillsSection1'>

                    <div className='skillsHeading'>
                        <h1 data-aos="fade-up"
                            data-aos-offset="200"
                            data-aos-delay="50"
                            data-aos-duration="1000"
                            className='aboutHeading'>Portfolio</h1>
                    </div>

                    <div className="gallery_container">


                        <div className="gallery_item">

                            <img alt="" src={post001}></img>

                        </div>

                        <div className="gallery_item">

                            <img alt="" src={post002}></img>

                        </div>
                        <div className="gallery_item">

                            <img alt="" src={post003}></img>

                        </div>
                        <div className="gallery_item">

                            <img alt="" src={post004}></img>

                        </div>

                        <div className="gallery_item">

                            <img alt="" src={post005}></img>

                        </div>

                        <div className="gallery_item">

                            <img alt="" src={post006}></img>

                        </div>
                        <div className="gallery_item">

                            <img alt="" src={post007}></img>

                        </div>
                        <div className="gallery_item">

                            <img alt="" src={post008}></img>

                        </div>
                        <div className="gallery_item">

                            <img alt="" src={post009}></img>

                        </div>

                        <div className="gallery_item">

                            <img alt="" src={post010}></img>

                        </div>
                        <div className="gallery_item">

                            <img alt="" src={post011}></img>

                        </div>
                        <div className="gallery_item">

                            <img alt="" src={post012}></img>

                        </div>


                    </div>

                </section>


            </div>
            <Footer />
        </div>
    )
};

export default Portfolio;